module.exports = __webpack_public_path__ + "static/media/TP_MarkspotV2.4006b090.png";